import { useState } from "react";
import { Box, Grid2 } from "@mui/material";
import { HexColorInput } from "react-colorful";

type P = {
  color: string | null;
  setColor: (newColor: string) => void;
};
export function ColorPicker({ color, setColor }: Readonly<P>) {
  const twitterColors = [
    "#FF6900",
    "#FCB900",
    "#7BDCB5",
    "#00D084",
    "#8ED1FC",
    "#0693E3",
    "#ABB8C3",
    "#EB144C",
    "#F78DA7",
    "#9900EF"
  ];

  const [pickColor, setPickColor] = useState(color ?? twitterColors[0]);

  const handleChangeColor = (newColor: string) => {
    setColor(newColor);
    setPickColor(newColor);
  };

  return (
    <Grid2 container sx={{ mt: 2, width: 280 }}>
      <Box
        data-testid="color-picker-parent-box"
        sx={{
          position: "relative",
          display: "inline-block",
          p: 2,
          bgcolor: "#ffffff",
          borderRadius: 1,
          boxShadow: 3,
          "&::before": {
            content: '""',
            position: "absolute",
            top: "-14px", // move it up by arrow height
            left: "5.5%",
            transform: "translateX(-50%)",
            width: 0,
            height: 0,
            borderLeft: "16px solid transparent",
            borderRight: "16px solid transparent",
            borderBottom: `16px solid #ffffff`
          }
        }}
      >
        <Grid2 sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {/* sample colors */}
          {twitterColors.map((color, index) => (
            <button
              key={color}
              data-testid={`${index}-color-btn`}
              onClick={() => handleChangeColor(color)}
              style={{
                width: 32,
                height: 32,
                borderRadius: 4,
                border: pickColor === color ? "2px solid black" : "1px solid #ccc",
                background: color,
                cursor: "pointer"
              }}
            />
          ))}

          {/* color picker input */}
          <Grid2 container sx={{ height: 32, alignContent: "center" }}>
            <Grid2
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 24,
                borderTopLeftRadius: 4,
                borderBottomLeftRadius: 4,
                background: "#B6BDBF",
                color: "#98A1A4"
              }}
            >
              #
            </Grid2>

            <HexColorInput
              id="hex-color-input"
              data-testid="hex-color-input"
              name="hex-color-input"
              color={pickColor}
              onChange={handleChangeColor}
              style={{
                width: "116px",
                height: "30px",
                borderTopRightRadius: 4,
                borderBottomRightRadius: 4
              }}
            />
          </Grid2>
        </Grid2>
      </Box>
    </Grid2>
  );
}
